import { BaseEdge, EdgeLabelRenderer, EdgeProps, getSmoothStepPath, useReactFlow } from 'reactflow'
import { tokens } from 'styling/tokens'
import { TaskLogicEdgeDeleteButton } from '../DragComponents/Tasks.styled'

type TaskLogicEdgeData = {
  variant?: 'input' | 'output'
  onRemove?: (id: string) => void
}

export const TaskLogicEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  selected,
  markerEnd,
  data,
}: EdgeProps<TaskLogicEdgeData>) => {
  const { setEdges } = useReactFlow()
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  })

  const variant = data?.variant ?? 'input'
  const color = tokens.accent.base

  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (data?.onRemove) {
      data.onRemove(id)
    } else {
      setEdges((edges) => edges.filter((edge) => edge.id !== id))
    }
  }

  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          stroke: color,
          strokeWidth: 2,
          strokeDasharray: variant === 'output' ? '6 4' : undefined,
        }}
      />
      <EdgeLabelRenderer>
        <TaskLogicEdgeDeleteButton
          show={Boolean(selected)}
          style={{ transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)` }}
          onClick={handleRemove}
          title='Remove link'
        >
          ×
        </TaskLogicEdgeDeleteButton>
      </EdgeLabelRenderer>
    </>
  )
}
